export default __webpack_public_path__ + "static/media/35.41a8f9d8.jpg";